import { Controller } from "@hotwired/stimulus"

// Reveals/hides the business-billing fields when the "Buying as a business?"
// checkbox is toggled, and updates the tax-ID label + hidden type field
// based on the chosen country.
export default class extends Controller {
  static targets = ["checkbox", "fields", "country", "taxIdGroup", "taxIdLabel", "taxIdType"]

  static COUNTRY_TO_TAX = {
    NZ: { type: "nz_gst", label: "NZ GST" },
    AU: { type: "au_abn", label: "AU ABN" },
    GB: { type: "gb_vat", label: "UK VAT" },
    US: { type: "us_ein", label: "US EIN" },
  }

  toggle() {
    const show = this.checkboxTarget.checked
    this.fieldsTarget.classList.toggle("hidden", !show)
  }

  countryChanged() {
    const code = (this.countryTarget.value || "").toUpperCase()
    const map = this.constructor.COUNTRY_TO_TAX[code]

    if (this.hasTaxIdGroupTarget) {
      this.taxIdGroupTarget.classList.toggle("hidden", !map)
    }
    if (this.hasTaxIdTypeTarget) {
      this.taxIdTypeTarget.value = map ? map.type : ""
    }
    if (this.hasTaxIdLabelTarget) {
      this.taxIdLabelTarget.textContent = map ? map.label : ""
    }
  }
}
